import { createFileRoute, redirect } from '@tanstack/react-router';

/** Retired tab — the defaults now live in the single Recurring jobs page. */
export const Route = createFileRoute('/_dashboard/dashboard/settings/contracts/defaults')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/contracts' });
  },
  component: () => null,
});
